var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7221 68.8502C74.5553 68.8502 74.3995 68.806 74.2547 68.7285L72.7747 67.8536C72.5521 67.7317 72.6634 67.6875 72.7302 67.6653C73.0306 67.5657 73.0863 67.5435 73.3979 67.3664C73.4313 67.3442 73.4759 67.3553 73.5092 67.3774L74.6443 68.0529C74.6888 68.0751 74.7445 68.0751 74.7778 68.0529L79.2181 65.4948C79.2626 65.4726 79.2849 65.4283 79.2849 65.373V60.2678C79.2849 60.2123 79.2626 60.1681 79.2181 60.1459L74.7778 57.5988C74.7333 57.5766 74.6776 57.5766 74.6443 57.5988L70.204 60.1459C70.1595 60.168 70.1372 60.2234 70.1372 60.2677V65.3729C70.1372 65.4172 70.1595 65.4725 70.204 65.4948L71.4171 66.1924C72.0736 66.5246 72.4854 66.137 72.4854 65.7494V60.7106C72.4854 60.6442 72.541 60.5777 72.6189 60.5777H73.1864C73.2533 60.5777 73.32 60.6331 73.32 60.7106V65.7494C73.32 66.6243 72.8414 67.1337 72.0068 67.1337C71.7509 67.1337 71.5506 67.1337 70.983 66.8568L69.8145 66.1924C69.5252 66.0264 69.3472 65.7162 69.3472 65.384V60.2788C69.3472 59.9466 69.5252 59.6364 69.8145 59.4703L74.2547 56.9122C74.533 56.7571 74.9114 56.7571 75.1896 56.9122L79.6298 59.4703C79.9192 59.6364 80.0973 59.9466 80.0973 60.2788V65.384C80.0973 65.7162 79.9192 66.0264 79.6298 66.1924L75.1896 68.7506C75.0449 68.8171 74.878 68.8502 74.7222 68.8502H74.7221ZM76.091 65.3397C74.1435 65.3397 73.7429 64.4538 73.7429 63.7007C73.7429 63.6342 73.7985 63.5678 73.8764 63.5678H74.4551C74.5219 63.5678 74.5775 63.6121 74.5775 63.6786C74.6666 64.2655 74.9225 64.5534 76.1021 64.5534C77.0369 64.5534 77.4376 64.343 77.4376 63.8447C77.4376 63.5567 77.3262 63.3464 75.8684 63.2024C74.6554 63.0805 73.8987 62.8148 73.8987 61.8513C73.8987 60.9543 74.6555 60.4227 75.9241 60.4227C77.3485 60.4227 78.0496 60.91 78.1387 61.973C78.1387 62.0064 78.1275 62.0395 78.1053 62.0728C78.0829 62.0949 78.0496 62.1171 78.0162 62.1171H77.4375C77.3819 62.1171 77.3262 62.0728 77.3152 62.0174C77.1816 61.4084 76.8366 61.209 75.9241 61.209C74.9003 61.209 74.7778 61.5634 74.7778 61.8291C74.7778 62.1503 74.9225 62.25 76.3024 62.4271C77.6712 62.6044 78.3167 62.8591 78.3167 63.8114C78.3056 64.786 77.5044 65.3397 76.091 65.3397Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9544 48.884C60.9544 48.6847 60.8431 48.4963 60.6651 48.3967L55.9466 45.6946C55.8686 45.6502 55.7796 45.6281 55.6907 45.617H55.6461C55.5571 45.617 55.468 45.6502 55.3901 45.6946L50.6717 48.3967C50.4935 48.4963 50.3823 48.6846 50.3823 48.884L50.3935 56.1487C50.3935 56.2483 50.4491 56.348 50.5381 56.3924C50.6272 56.4477 50.7384 56.4477 50.8164 56.3924L53.6208 54.7976C53.7988 54.698 53.9101 54.5097 53.9101 54.3104V50.9106C53.9101 50.7113 54.0213 50.523 54.1995 50.4233L55.3901 49.7367C55.4792 49.6813 55.5793 49.6591 55.6795 49.6591C55.7796 49.6591 55.8798 49.6813 55.9578 49.7367L57.1484 50.4233C57.3266 50.523 57.4378 50.7112 57.4378 50.9106V54.3104C57.4378 54.5097 57.5491 54.698 57.7271 54.7976L60.5315 56.3924C60.6206 56.4477 60.7318 56.4477 60.8209 56.3924C60.9099 56.348 60.9656 56.2483 60.9656 56.1487L60.9544 48.884ZM83.6343 38.8839C83.5453 38.8395 83.434 38.8395 83.356 38.8839C83.267 38.9392 83.2114 39.0278 83.2114 39.1274V46.3258C83.2114 46.3922 83.178 46.4586 83.1112 46.503C83.0445 46.5361 82.9777 46.5361 82.9109 46.503L81.7313 45.8275C81.6448 45.7785 81.547 45.7527 81.4475 45.7527C81.348 45.7527 81.2502 45.7785 81.1637 45.8275L76.4452 48.5407C76.2672 48.6403 76.1559 48.8286 76.1559 49.0279V54.4432C76.1559 54.6425 76.2672 54.8309 76.4452 54.9305L81.1637 57.6437C81.2502 57.6927 81.348 57.7185 81.4475 57.7185C81.547 57.7185 81.6448 57.6927 81.7313 57.6437L86.4498 54.9305C86.6278 54.8309 86.7391 54.6426 86.7391 54.4432V40.9437C86.7391 40.7333 86.6278 40.5451 86.4498 40.4453L83.6343 38.8839H83.6343ZM83.2003 52.6603C83.2003 52.7157 83.178 52.76 83.1335 52.7821L81.5199 53.7123C81.4973 53.7232 81.4726 53.7289 81.4475 53.7289C81.4224 53.7289 81.3977 53.7232 81.3752 53.7123L79.7616 52.7821C79.717 52.76 79.6947 52.7046 79.6947 52.6603V50.7998C79.6947 50.7444 79.717 50.7001 79.7616 50.678L81.3752 49.7477C81.3977 49.7368 81.4224 49.7311 81.4475 49.7311C81.4726 49.7311 81.4973 49.7368 81.5199 49.7477L83.1335 50.678C83.178 50.7 83.2003 50.7555 83.2003 50.7998V52.6603ZM99.3365 50.7555C99.5147 50.6559 99.6148 50.4676 99.6148 50.2682V48.9504C99.6148 48.7511 99.5035 48.5628 99.3365 48.4632L94.6515 45.7611C94.565 45.7121 94.4672 45.6863 94.3677 45.6863C94.2682 45.6863 94.1704 45.7121 94.084 45.7611L89.3655 48.4742C89.1873 48.5738 89.0761 48.7621 89.0761 48.9615V54.3768C89.0761 54.5761 89.1873 54.7644 89.3655 54.864L94.0505 57.5219C94.2287 57.6215 94.44 57.6215 94.607 57.5219L97.4447 55.9495C97.5337 55.9051 97.5894 55.8055 97.5894 55.7058C97.5894 55.6062 97.5337 55.5065 97.4447 55.4621L92.704 52.7489C92.615 52.6937 92.5593 52.605 92.5593 52.5054V50.811C92.5593 50.7114 92.615 50.6117 92.704 50.5673L94.1841 49.7257C94.2274 49.6985 94.2776 49.6841 94.3288 49.6841C94.38 49.6841 94.4301 49.6985 94.4734 49.7257L95.9535 50.5673C96.0425 50.6227 96.0982 50.7113 96.0982 50.811V52.1399C96.0982 52.2396 96.1538 52.3392 96.2428 52.3835C96.3319 52.4389 96.4431 52.4389 96.5322 52.3835L99.3365 50.7555Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2886 50.5005C94.3052 50.4897 94.3245 50.4839 94.3443 50.4839C94.364 50.4839 94.3834 50.4897 94.3999 50.5005L95.3013 51.021C95.3347 51.043 95.357 51.0762 95.357 51.1206V52.1616C95.357 52.2058 95.3347 52.2391 95.3013 52.2612L94.3999 52.7817C94.3834 52.7925 94.364 52.7983 94.3443 52.7983C94.3245 52.7983 94.3052 52.7925 94.2886 52.7817L93.3872 52.2612C93.3538 52.2391 93.3315 52.2058 93.3315 52.1616V51.1206C93.3315 51.0762 93.3538 51.043 93.3872 51.021L94.2886 50.5005Z",
    fill: "#539E43"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3785_11431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 45,
    width: 11,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8424 45.7818C68.7559 45.7328 68.6581 45.707 68.5586 45.707C68.4591 45.707 68.3613 45.7328 68.2749 45.7818L63.5898 48.4727C63.4117 48.5723 63.3115 48.7606 63.3115 48.9599V54.3531C63.3115 54.5525 63.4228 54.7407 63.5898 54.8404L68.2749 57.5315C68.3613 57.5804 68.4591 57.6062 68.5586 57.6062C68.6581 57.6062 68.7559 57.5804 68.8424 57.5315L73.5275 54.8404C73.7056 54.7407 73.8058 54.5525 73.8058 54.3531V48.96C73.8058 48.7607 73.6944 48.5724 73.5275 48.4727L68.8424 45.7818Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3785_11431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8404 45.7818C68.7539 45.7328 68.6562 45.707 68.5567 45.707C68.4572 45.707 68.3594 45.7328 68.2729 45.7818L63.5878 48.4727C63.4097 48.5723 63.3096 48.7606 63.3096 48.9599V54.3531C63.3096 54.5525 63.4209 54.7407 63.5878 54.8404L68.2729 57.5315C68.3594 57.5804 68.4572 57.6062 68.5567 57.6062C68.6562 57.6062 68.7539 57.5804 68.8404 57.5315L73.5256 54.8404C73.7036 54.7407 73.8038 54.5525 73.8038 54.3531V48.96C73.8038 48.7607 73.6924 48.5724 73.5256 48.4727L68.8404 45.7818Z",
    fill: "url(#paint0_linear_3785_11431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5361 48.4739L68.8288 45.7829C68.7826 45.7597 68.7341 45.7411 68.6841 45.7275L63.4092 54.7199C63.4529 54.773 63.5056 54.818 63.5651 54.8528L68.2724 57.5439C68.4059 57.6214 68.5617 57.6436 68.7063 57.5992L73.6586 48.5848C73.6252 48.5405 73.5806 48.5071 73.5361 48.474V48.4739Z",
    fill: "url(#paint1_linear_3785_11431)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5646 54.8413C73.6981 54.7638 73.7983 54.6309 73.8428 54.487L68.679 45.7161C68.5455 45.694 68.4008 45.705 68.2785 45.7825L63.6045 48.4626L68.6456 57.6099C68.7189 57.598 68.7901 57.5756 68.8571 57.5435L73.5645 54.8414L73.5646 54.8413Z",
    fill: "url(#paint2_linear_3785_11431)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5537 54.841L68.8574 57.5321C68.7911 57.5657 68.7197 57.5882 68.646 57.5985L68.7351 57.7647L73.9431 54.7636V54.6971L73.8096 54.4756C73.7874 54.6306 73.6872 54.7635 73.5537 54.841Z",
    fill: "url(#paint3_linear_3785_11431)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5537 54.841L68.8574 57.5321C68.7911 57.5657 68.7197 57.5882 68.646 57.5985L68.7351 57.7647L73.9431 54.7636V54.6971L73.8096 54.4756C73.7874 54.6306 73.6872 54.7635 73.5537 54.841Z",
    fill: "url(#paint4_linear_3785_11431)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3785_11431",
    x1: 70.4654,
    y1: 47.7878,
    x2: 65.3657,
    y2: 55.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3785_11431",
    x1: 67.8448,
    y1: 52.2895,
    x2: 80.6772,
    y2: 45.2835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3785_11431",
    x1: 63.1551,
    y1: 51.6576,
    x2: 73.9963,
    y2: 51.6576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3785_11431",
    x1: 63.1443,
    y1: 56.1292,
    x2: 73.9854,
    y2: 56.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3785_11431",
    x1: 75.5648,
    y1: 47.5334,
    x2: 72.8441,
    y2: 61.8596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.6b4cbab16bd2e1a88a0051651626af94.svg";
export { ForwardRef as ReactComponent };